/**
 * Extraction Stats Cards Component
 * Displays statistics about AI-extracted menu data
 */

import { Package, Tag } from 'lucide-react';
import React from 'react';

interface ExtractionStatsProps {
  categories: number;
  items: number;
  addons: number;
}

interface StatCardProps {
  value: number;
  label: string;
  icon: React.ReactNode;
  iconBgColor: string;
}

const StatCard: React.FC<StatCardProps> = ({
  value,
  label,
  icon,
  iconBgColor,
}) => (
  <div className="bg-white rounded-lg border border-gray-200 p-4 flex items-center gap-3">
    <div
      className={`w-10 h-10 rounded-lg flex items-center justify-center ${iconBgColor}`}
    >
      {icon}
    </div>
    <div>
      <p className="text-2xl font-semibold text-gray-900">{value}</p>
      <p className="text-sm text-gray-500">{label}</p>
    </div>
  </div>
);

export const ExtractionStats: React.FC<ExtractionStatsProps> = ({
  categories,
  items,
  addons,
}) => {
  return (
    <div className="grid grid-cols-3 gap-4">
      <StatCard
        value={categories}
        label="Categories"
        icon={<Tag size={20} className="text-blue-600" />}
        iconBgColor="bg-blue-100"
      />
      <StatCard
        value={items}
        label="Items"
        icon={<Package size={20} className="text-green-600" />}
        iconBgColor="bg-green-100"
      />
      <StatCard
        value={addons}
        label="Addons"
        icon={<Package size={20} className="text-purple-600" />}
        iconBgColor="bg-purple-100"
      />
    </div>
  );
};
